// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pT-S","question":"styles_question__t771p","description":"styles_description__338Vp"};